import React from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from 'react-google-maps';

import { markerContainer, markerContent } from 'constants/styles';

import LocationNameDisplay from 'components/LocationNameDisplay';
import Button from 'components/Button';
import LinkButton from 'components/LinkButton';

import { openUrl } from 'utils/window';

export default class MarkerComponent extends React.Component {
  handleMoreInfo = () => {
    const { location } = this.props;
    openUrl(location.url);
  };

  getGoogleMapsUrl = () => {
    const { location } = this.props;
    const googleMapsUri = 'https://www.google.com/maps/search/?api=1';
    let searchUrl = '';
    const lat = parseFloat(location.lat);
    const lng = parseFloat(location.lng);
    if (location.google_place_id) {
      searchUrl = `${googleMapsUri}&query=${lat},${lng}&query_place_id=${location.google_place_id}`;
    } else {
      const urlSafeAddress = encodeURI(location.address);
      searchUrl = `${googleMapsUri}&query=${urlSafeAddress}`;
    }
    return searchUrl;
  };

  getMarkerProps = () => {
    const { location, markerIcon, handleToggleOpen } = this.props;
    const markerProps = {
      position: {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lng),
      },
      onClick: () => handleToggleOpen(location.id),
      title: location.name,
    };
    if (markerIcon != 'https://getbento.imgix.net/' && markerIcon) {
      markerProps.icon = markerIcon;
    }
    return markerProps;
  };

  displayCustomButton = () => {
    const { location } = this.props;
    return (
      location.store_locator_custom_button_text &&
      location.store_locator_custom_button_url
    );
  };

  render() {
    const {
      activeId,
      handleToggleClose,
      location,
      displayMoreInfo,
    } = this.props;
    const markerProps = this.getMarkerProps();
    return (
      <Marker {...markerProps}>
        {activeId == location.id && (
          <InfoWindow onCloseClick={handleToggleClose}>
            <div style={markerContainer} id="infoWindow">
              <LocationNameDisplay
                id="infoWindow-title"
                name={location.name}
                url={location.url}
              />
              {location.address && (
                <a
                  style={markerContent}
                  href={this.getGoogleMapsUrl()}
                  target="_blank"
                  id="infoWindow-address"
                >
                  {location.street}
                  <br id="infoWindow-address-break" />
                  {location.city}, {location.state} {location.postal_code}
                </a>
              )}
              <br id="infoWindow-break" />
              {location.phone_number && (
                <React.Fragment>
                  <a
                    style={markerContent}
                    href={`tel:${location.phone_number}`}
                    id="infoWindow-phone"
                  >
                    {location.phone_number}
                  </a>
                  <br id="infoWindow-break" />
                </React.Fragment>
              )}
              {displayMoreInfo && (
                <Button
                  label="Location Details"
                  handleClick={this.handleMoreInfo}
                  id="infoWindow-moreInfo"
                  addTopMargin
                />
              )}
              {this.displayCustomButton() && (
                <LinkButton
                  className="locationListItem-customButton locationListItem-link"
                  label={location.store_locator_custom_button_text}
                  addTopMargin
                  href={location.store_locator_custom_button_url}
                  isExternal
                />
              )}
            </div>
          </InfoWindow>
        )}
      </Marker>
    );
  }
}

MarkerComponent.propTypes = {
  activeId: PropTypes.number,
  displayMoreInfo: PropTypes.bool.isRequired,
  handleToggleClose: PropTypes.func.isRequired,
  handleToggleOpen: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  markerIcon: PropTypes.string,
};
